export default __webpack_public_path__ + "static/fire_extinguisher_b.59fb8af4b7e554436a5f108ca997c58d.png";